/**
 * SignInLoadingScreen component
 * Shows loading state while auth initializes.
 * Matches join deep-link loading (dark gradient) so no visual jump from invite links.
 */

import React, { useContext } from 'react';
import { JoinFlowLoadingScreen } from '../../src/join/components/JoinFlowLoadingScreen';
import { LanguageContext } from '../../src/i18n';

interface SignInLoadingScreenProps {
  /** Test ID for testing */
  testID?: string;
}

export const SignInLoadingScreen: React.FC<SignInLoadingScreenProps> = ({ testID }) => {
  const languageContext = useContext(LanguageContext);
  const message = languageContext?.t.signIn.loading ?? 'Loading…';
  return (
    <JoinFlowLoadingScreen message={message} testID={testID || 'sign-in-loading-screen'} />
  );
};
